import { environment } from 'src/environments/environment';

export const API_URL: string = environment.api_url;
export const JustifiClientId: string = environment.JustifiClientId;
export const API_ENDPOINTS = {
  //Portal Url
  getPortalUrlDetails: 'api/PortalUrl/getUrlLinkDetails',
  updatePortalEstimate: 'api/PortalUrl/updatePortalEstimate',
  updateSelectionOption: 'api/PortalUrl/UpdateSelectionOption',
  getInvoicePayments: 'api/PortalUrl/getInvoicePayments',
  getUpdatedDateOfEntity: 'api/PortalUrl/UpdatedDateOfEntity',

  // setting 
  getSettings:'api/PortalUrl/Settings',

  //checkout
  JustFiCheckOutPayment:'api/JustiFi/CheckoutPayment',
};

export const ENDPOINT_NAMES_TO_LOG = [
  'getUrlLinkDetails',
  'updatePortalEstimate',
]